import React, { useEffect, useState } from "react";
import { Row, Col, Button, Spin, Avatar, Tooltip, Modal, List, message } from "antd";
import moment from "moment";
// import PeriodCycleTracker from "../../../screens/PatientDashboard/Cycle/cycle";
import { useDispatch } from "react-redux";
import { getMiraInfo, getUserProfile } from "../../redux/AuthController";
import { getAccessDetails } from "../../redux/AssessmentController";
import {
  CheckOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import "../dashboard.css";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import MiraButton from "../../../assets/images/mirabutton.svg";
import calendarBookingIcon from "../../../assets/images/calendar.svg";
import shopPlansIcon from "../../../assets/images/shop.svg";

import {
  CalendarOutlined,
  ClockCircleOutlined,
  DownloadOutlined,
  DownOutlined,
  EnvironmentOutlined,
  ExperimentOutlined,
  EyeOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  UpOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import CircleWithArc from "./periodchart";
import MiraAccountSetupMessage from "./MiraAccountSetupMessage";
import MiraSyncModal from "./MiraSyncModal";
import { getPatientStatus, getPatientAppointmentList, fetchDocumo, downloadDocumo } from "../../redux/patientSlice";
import { getPatientCredits } from "../../redux/creditsSlice";
import { mergeAppointments, splitUpcomingPast } from "../../../utils/normalizeAppointments";
import { CREDIT_BEARING_CATEGORIES } from "../../../utils/providerCategories";
import { VirtualCareConsentModal } from "./PatientAppointments";
import CardComponent from "../../UI/CardComponent";
import DashboardPanelCard from "../../UI/DashboardPanelCard";
const cycleData = {
  cycleInfo: {
    cycle_length: 29,
    period_start: "2024-07-08",
    period_end: "2024-07-13",
    fertile_window_start: "2024-07-17",
    fertile_window_end: "2024-07-24",
    ovulation: "2024-07-21",
  },
  dailyLog: {
    symptoms: [
      {
        value: "Headache",
        level: "Mild",
      },
      {
        value: "Nausea",
        level: "Mild",
      },
      {
        value: "Cravings",
        level: "Mild",
      },
    ],
    mood: "Happy",
    sex: "Yes, unprotected",
    cervical_mucous: {
      description: "Raw Egg White",
      volume: "Medium",
    },
    cervical_position: {
      height: "Middle",
      openness: "Closed",
      texture: "Medium",
    },
    flow_spotting: "Spotting",
  },
  statusCode: "200",
  status: true,
  message: "Successful",
};

export default function PatDash() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const zoomAppointments = useSelector((state) => state?.patient?.zoomAppointments);
  const credits = useSelector((state) => state.credits);
  const [cycleInfo, setCycleInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [, setCurrentStep] = useState(0);
  const { userAuth } = useSelector((state) => state.authentication);
  const resolveGender = (data) => {
    const raw =
      data?.gender ||
      data?.Gender ||
      data?.sex ||
      data?.Sex ||
      data?.patientGender;
    if (!raw || typeof raw !== "string") return null;
    const val = raw.toLowerCase().trim();
    if (val.startsWith("m")) return "male";
    if (val.startsWith("f")) return "female";
    return val;
  };
  const isMale = resolveGender(userAuth?.obj ?? userAuth) === "male";
  const [patientStatus, setPatientStatus] = useState({ initialAssessment: null, isPaymentComplete: null });
  const [, setError] = useState(null);
  const [miraModalOpen, setMiraModalOpen] = useState(false);
  const [profileMiraEmail, setProfileMiraEmail] = useState("");
  const patientEmail =
    profileMiraEmail || userAuth?.obj?.email || userAuth?.email || "";
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [viewAll, setViewAll] = useState(false);
  const [checklistItems, setChecklistItems] = useState({
    intakeForms: false,
    learnVideos: false
  });
  const [profileLoaded, setProfileLoaded] = useState(false);
  const accessDetails = useSelector((state) => state.intake.accessDetails);
  const documoData = useSelector((state) => state.patient?.documoData);
  const documoLoading = useSelector((state) => state.patient?.documoLoading);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewMessageNumber, setPreviewMessageNumber] = useState(null);

  const normalizePatientStatus = (payload) => {
    let data = payload;
    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch {
        // leave as-is
      }
    }
    if (!data || typeof data !== "object") return null;

    const normalizeBool = (v) => {
      if (typeof v === "boolean") return v;
      if (typeof v === "string") {
        const t = v.trim().toLowerCase();
        if (t === "true") return true;
        if (t === "false") return false;
      }
      return v ?? null;
    };

    return {
      initialAssessment: normalizeBool(data.initialAssessment ?? data.InitialAssessment),
      isPaymentComplete: normalizeBool(data.isPaymentComplete ?? data.IsPaymentComplete),
    };
  };

  const getAccessDetailsStatus = () => {
    if (!accessDetails) return false;
    return Object.values(accessDetails).every(value => value === true);
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await dispatch(getUserProfile());
        console.log('User Profile Response:', response);
        console.log('Current userAuth:', userAuth);

        const profile = response.payload?.obj ?? response.payload;
        const savedMiraEmail = profile?.miraEmail ?? profile?.MIRAEmail;
        setProfileMiraEmail(
          typeof savedMiraEmail === "string" ? savedMiraEmail.trim() : "",
        );
        
        const hasPharmacy = response.payload?.pharmacyName !== null;
        // Check both sources for video watching status
        const hasWatchedVideos = response.payload?.videoWatched === true || 
                               userAuth?.obj?.videoWatched === true ||
                               userAuth?.obj?.videoWatched === "true";
        
        console.log('Has watched videos:', hasWatchedVideos, hasPharmacy);
        
        setChecklistItems(prev => ({
          ...prev,
          learnVideos: hasWatchedVideos,
          pharmacy: hasPharmacy,
        }));
      } catch (error) {
        console.error('Error fetching user profile:', error);
      } finally {
        setProfileLoaded(true);
      }
    };

    if (userAuth?.obj?.token) {
      fetchUserProfile();
    }
  }, [dispatch, userAuth]);

  // Faxed labs (bloodwork, semen sample, ultrasound, etc.) mapped to this patient
  useEffect(() => {
    if (userAuth?.obj?.token) {
      dispatch(fetchDocumo());
    }
  }, [dispatch, userAuth?.obj?.token]);

  const handleDownloadDocumo = async (messageNumber) => {
    try {
      const response = await dispatch(downloadDocumo(messageNumber)).unwrap();
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `documo_${messageNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch {
      message.error("Failed to download document");
    }
  };

  const handleViewDocumo = async (messageNumber) => {
    try {
      setPreviewMessageNumber(messageNumber);
      const response = await dispatch(downloadDocumo(messageNumber)).unwrap();
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      setPreviewUrl(url);
      setPreviewOpen(true);
    } catch {
      message.error("Failed to load document preview");
    }
  };

  const onClosePreview = () => {
    setPreviewOpen(false);
    if (previewUrl) {
      window.URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(null);
    setPreviewMessageNumber(null);
  };

  // Check if all checklist items are complete
  useEffect(() => {
    const allComplete = checklistItems.intakeForms && 
                       checklistItems.learnVideos && 
                       checklistItems.pharmacy;
    
    // Check if user has already seen the congratulations modal
    const hasSeenCongratulations = localStorage.getItem('hasSeenCongratulations');
    
    if (allComplete && !hasSeenCongratulations) {
      setShowCongratulationsModal(true);
      // Mark that user has seen the modal
      localStorage.setItem('hasSeenCongratulations', 'true');
    }
  }, [checklistItems]);

  
  const upcomingAppointments = React.useMemo(() => {
    const merged = mergeAppointments({ zoom: zoomAppointments, viewer: "patient" });
    return splitUpcomingPast(merged).upcoming;
  }, [zoomAppointments]);

  const visibleAppointments = viewAll
    ? upcomingAppointments
    : upcomingAppointments.slice(0, 2);

  const handleViewAll = () => {
    setViewAll(!viewAll);
  };

  const [pendingMeetingLink, setPendingMeetingLink] = useState(null);

  const handleConfirmConsent = () => {
    if (pendingMeetingLink) window.open(pendingMeetingLink, "_blank", "noopener,noreferrer");
    setPendingMeetingLink(null);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showCongratulationsModal, setShowCongratulationsModal] = useState(false);

  const showCyleModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCongratulationsOk = () => {
    setShowCongratulationsModal(false);
  };

  // Function to reset congratulations modal (for testing purposes)
  // const resetCongratulationsModal = () => {
  //   localStorage.removeItem('hasSeenCongratulations');
  //   setShowCongratulationsModal(false);
  // };

  useEffect(() => {
    let intervalId;

    if (userAuth?.obj?.token) {
      const fetchPatientStatus = async () => {
        try {
          const result = await dispatch(getPatientStatus());
          const normalized = normalizePatientStatus(result.payload);
          if (normalized) setPatientStatus(normalized);
        } catch (err) {
          console.error("Error fetching patient status:", err);
        }
      };

      fetchPatientStatus();
      intervalId = setInterval(fetchPatientStatus, 10000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [userAuth?.obj?.token, dispatch]);

  useEffect(() => {
    const fetchMiraInfo = async () => {
      setLoading(true);
      setError(null);

      try {
        console.log("Dispatching getMiraInfo");

        const resultAction = await dispatch(getMiraInfo());

        console.log(resultAction, "Result Action");

        if (getMiraInfo.fulfilled.match(resultAction)) {
          setCycleInfo(resultAction.payload);
        } else {
          setError(resultAction.payload || "Failed to fetch Mira Info");
        }
      } catch (err) {
        console.error("Error occurred:", err);
        setError("An unexpected error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchMiraInfo();
  }, [dispatch]);

  useEffect(() => {
    const storedStep = localStorage.getItem("currentStep");
    if (storedStep) {
      setCurrentStep(parseInt(storedStep, 10));
    }
  }, []);

  useEffect(() => {
    dispatch(getPatientAppointmentList());
    dispatch(getPatientCredits());
  }, [dispatch]);

  useEffect(() => {
    if (userAuth?.obj?.token) {
      dispatch(getAccessDetails());
    }
  }, [userAuth?.obj?.token, dispatch]);

  const intakeFormsComplete =
    patientStatus?.initialAssessment === true || patientStatus?.initialAssessment === "true"
      ? true
      : getAccessDetailsStatus();
  const profilePharmacyComplete = Boolean(checklistItems?.pharmacy);
  const showRequirementsAlert =
    Boolean(userAuth?.obj?.token) &&
    profileLoaded &&
    (!profilePharmacyComplete || !intakeFormsComplete);

  const requirementsListLineStyle = {
    margin: 0,
    color: "#262626",
    fontSize: 12,
    lineHeight: 1.55,
  };

  /** Inline links (not buttons) so line height matches body text */
  const dashInlineLink = {
    color: "#01ADF0",
    display: "inline",
    padding: 0,
    margin: 0,
    fontSize: 12,
    lineHeight: 1.55,
    fontFamily: "inherit",
    fontWeight: 600,
    textDecoration: "none",
    verticalAlign: "baseline",
  };

  const requirementCheckbox = (checked) => (
    <span
      aria-hidden
      style={{
        width: 18,
        height: 18,
        borderRadius: 4,
        border: checked ? "1px solid #01ADF0" : "1px solid #bfbfbf",
        flexShrink: 0,
        marginTop: 3,
        backgroundColor: checked ? "#01ADF0" : "#fff",
        boxSizing: "border-box",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {checked ? <CheckOutlined style={{ color: "#fff", fontSize: 12, lineHeight: 1 }} /> : null}
    </span>
  );

  // Credits are bucketed per provider category - booking a doula must never
  // draw down the clinician pool - so the rows come straight off the shared
  // category list rather than a second hardcoded copy of it.
  const appointmentCreditRows = CREDIT_BEARING_CATEGORIES.map((category) => ({
    label: category.label,
    remaining: credits?.[category.creditKey]?.remaining ?? 0,
  }));

  /** Full-width button shell: centers a fixed-width inner row */
  const bookPlansPrimaryBtn = {
    background: "#01ADF0",
    borderColor: "#01ADF0",
    borderRadius: 12,
    fontWeight: 600,
    height: 44,
    color: "#fff",
    fontFamily: "Montserrat, sans-serif",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingInline: 12,
  };

  /** Narrow strip inside the button; icon + label align left within this width */
  const bookPlansBtnInnerRow = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 8,
    width: 260,
    maxWidth: "100%",
    boxSizing: "border-box",
  };

  /** Body copy for DashboardPanelCard empty / info lines */
  const dashPanelEmptyTextStyle = {
    margin: 0,
    color: "#595959",
    fontSize: 14,
    lineHeight: 1.55,
    fontFamily: "Montserrat, sans-serif",
  };

  /** Centered empty state for dashboard panel cards */
  const DashboardPanelEmpty = ({ icon, title, description, footer }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: "28px 20px 32px",
        background: "linear-gradient(180deg, #fafbfd 0%, #f4f7fc 100%)",
        borderRadius: 12,
        border: "1px dashed #c5d6eb",
        marginTop: 4,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          background: "#fff",
          border: "1px solid #e2e8f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 16,
          color: "#335CAD",
          fontSize: 26,
          flexShrink: 0,
          boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
        }}
      >
        {icon}
      </div>
      <p
        style={{
          margin: 0,
          fontWeight: 700,
          fontSize: 15,
          color: "#0f172a",
          fontFamily: "Montserrat, sans-serif",
          letterSpacing: "0.01em",
        }}
      >
        {title}
      </p>
      {description ? (
        <p
          style={{
            margin: "10px 0 0",
            fontSize: 13,
            color: "#64748b",
            lineHeight: 1.55,
            maxWidth: 340,
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          {description}
        </p>
      ) : null}
      {footer ?? null}
    </div>
  );

  const labsAndDocumentsPanels = (
    <>
      <DashboardPanelCard className="mt-4" title="MOST RECENT LABS" style={{ width: "100%" }}>
        {documoLoading ? (
          <Spin size="small" />
        ) : documoData?.length ? (
          <List
            itemLayout="horizontal"
            dataSource={[...documoData].sort(
              (a, b) => new Date(b.faxReceivedAt) - new Date(a.faxReceivedAt)
            )}
            renderItem={(doc) => (
              <List.Item
                actions={[
                  <Button
                    key="view"
                    type="link"
                    icon={<EyeOutlined />}
                    onClick={() => handleViewDocumo(doc.messageNumber)}
                  >
                    View
                  </Button>,
                  <Button
                    key="download"
                    type="link"
                    icon={<DownloadOutlined />}
                    onClick={() => handleDownloadDocumo(doc.messageNumber)}
                  >
                    Download
                  </Button>,
                ]}
              >
                <List.Item.Meta
                  avatar={<FilePdfOutlined style={{ fontSize: 20, color: "#335CAD" }} />}
                  title={moment(doc.faxReceivedAt).format("MMM DD, YYYY")}
                  description={`${doc.pageCount} page${doc.pageCount === 1 ? "" : "s"} · #${doc.messageNumber}`}
                />
              </List.Item>
            )}
          />
        ) : (
          <DashboardPanelEmpty
            icon={<ExperimentOutlined />}
            title="No labs yet"
            description="When your care team orders labs, they will appear here."
          />
        )}
      </DashboardPanelCard>
      <DashboardPanelCard className="mt-4" title="DOCUMENTS" style={{ width: "100%" }}>
        <DashboardPanelEmpty
          icon={<FolderOpenOutlined />}
          title="No documents yet"
          description="Shared letters, forms, and files from your care team will show up here."
        />
      </DashboardPanelCard>
    </>
  );

  const bookPlansActions = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        ...(isMobile
          ? { gap: 12, justifyContent: "flex-start" }
          : {
              flex: 1,
              minHeight: 0,
              height: "100%",
              justifyContent: "space-evenly",
            }),
      }}
    >
      <p
        style={{
          margin: 0,
          lineHeight: 1.55,
          fontSize: isMobile ? 12 : 14,
          color: "#000000",
          fontFamily: "Montserrat, sans-serif",
          flexShrink: 0,
        }}
      >
        <Link
          to="/patient/services"
          className="no-underline"
          style={{
            color: "#01ADF0",
            fontWeight: 600,
            fontSize: "inherit",
          }}
        >
          Book
        </Link>{" "}
        an appointment today and explore our{" "}<br />
        <Link
          to="/plans"
          className="no-underline"
          style={{
            color: "#01ADF0",
            fontWeight: 600,
            fontSize: "inherit",
          }}
        >
          Plans
        </Link>{" "}
        to choose the package that&apos;s right for you!
      </p>
      <Button
        type="primary"
        block
        onClick={() => navigate("/patient/services")}
        style={{ ...bookPlansPrimaryBtn, flexShrink: 0 }}
      >
        <span style={bookPlansBtnInnerRow}>
          <img
            src={calendarBookingIcon}
            alt=""
            aria-hidden
            style={{ width: 20, height: 20, display: "block", flexShrink: 0 }}
          />
          <span style={{ lineHeight: 1.2 }}>Book Appointment</span>
        </span>
      </Button>
      <Button
        type="primary"
        block
        onClick={() => navigate("/plans")}
        style={{ ...bookPlansPrimaryBtn, flexShrink: 0 }}
      >
        <span style={bookPlansBtnInnerRow}>
          <img
            src={shopPlansIcon}
            alt=""
            aria-hidden
            style={{ width: 20, height: 20, display: "block", flexShrink: 0 }}
          />
          <span style={{ lineHeight: 1.2 }}>View Plans</span>
        </span>
      </Button>
    </div>
  );

  return (
    <div>
      {showRequirementsAlert && (
        <Row style={{ marginBottom: 16 }}>
          <Col span={24}>
            <CardComponent
              borderWidth={1}
              borderColor="#2F946C"
              headerColor="rgba(47, 148, 108, 0.12)"
              header={
                <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "flex-start" }}>
                  <span aria-hidden style={{ fontSize: 16, lineHeight: 1 }}>✅</span>
                  <span style={{ fontWeight: 700, color: "#2F946C", fontSize: 13 }}>
                    Next Steps
                  </span>
                </div>
              }
              headerStyle={{
                borderBottom: "1px solid rgba(47, 148, 108, 0.3)",
                textAlign: "left",
              }}
              bodyStyle={{ padding: "18px 20px" }}
              style={{ borderRadius: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.04)" }}
            >
                <p style={{ ...requirementsListLineStyle, marginBottom: 14 }}>
                  Please complete these steps when you can, and at least{" "}
                  <strong>72 hours before your appointment</strong>, so your
                  provider has time to review everything ahead of your visit.
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 12,
                    marginBottom: 14,
                  }}
                >
                  {requirementCheckbox(profilePharmacyComplete)}
                  <p style={requirementsListLineStyle}>
                    Complete your{" "}
                    <Link to="/profile" className="no-underline" style={dashInlineLink}>
                      Profile
                    </Link>{" "}
                    and{" "}
                    <Link to="/profile" className="no-underline" style={dashInlineLink}>
                      Pharmacy
                    </Link>{" "}
                    information
                  </p>
                </div>
                <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
                  {requirementCheckbox(intakeFormsComplete)}
                  <p style={requirementsListLineStyle}>
                    Complete your{" "}
                    <Link to="/assessment" className="no-underline" style={dashInlineLink}>
                      Intake Forms
                    </Link>
                  </p>
                </div>
            </CardComponent>
          </Col>
        </Row>
      )}

      <Row gutter={[32, 24]} align="stretch" wrap style={{ width: "100%", maxWidth: "100%" }}>
        <Col
          xs={24}
          md={15}
          lg={15}
          xl={16}
          style={{
            paddingBottom: 16,
            paddingTop: 20,
            minWidth: 0,
            maxWidth: "100%",
          }}
        >
          <Row gutter={[28, 24]} wrap align="stretch" style={{ marginBottom: 16 }}>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              style={{ minWidth: 0, display: "flex", flexDirection: "column" }}
            >
              <CardComponent
                header={
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: 14,
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                      lineHeight: 1.15,
                    }}
                  >
                    APPOINTMENT CREDITS REMAINING
                  </span>
                }
                headerColor="#0f7a1f"
                borderColor="#0f7a1f"
                borderWidth={2}
                headerStyle={{ textAlign: "center", padding: "16px 18px" }}
                bodyStyle={{ padding: "10px 20px 14px" }}
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  flex: "0 0 auto",
                }}
              >
                {appointmentCreditRows.map((row, idx) => (
                  <div
                    key={row.label}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "16px 0",
                      borderBottom:
                        idx < appointmentCreditRows.length - 1 ? "1px solid #f0f0f0" : "none",
                      fontSize: 15,
                      fontFamily: "Montserrat, sans-serif",
                    }}
                  >
                    <span style={{ color: "#000000", fontWeight: 500 }}>{row.label}</span>
                    <span style={{ fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                      {credits?.error ? (
                        // Don't render 0/0 on a failed fetch - that reads as
                        // "you have no credits" rather than "we couldn't check".
                        <span style={{ color: "#8c8c8c" }}>&mdash;</span>
                      ) : credits?.loading ? (
                        <Spin size="small" />
                      ) : (
                        <span style={{ color: row.remaining === 0 ? "#FF4D4F" : "#0f7a1f" }}>
                          {row.remaining}
                        </span>
                      )}
                    </span>
                  </div>
                ))}
              </CardComponent>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              style={{
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                alignSelf: "stretch",
              }}
            >
              {bookPlansActions}
            </Col>
          </Row>
          <DashboardPanelCard title="UPCOMING APPOINTMENTS">
            <div
              style={{
                order: isMobile ? 2 : 1,
              }}
            >
              {upcomingAppointments.length > 0 ? (
                <div>
                  {visibleAppointments.map((appointment, index) => (
                    <React.Fragment
                      key={`${appointment.source}-${appointment.id ?? ""}-${appointment.startMoment.valueOf()}`}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          gap: 16,
                          padding: "16px 18px",
                          marginBottom: 12,
                          background: "#fff",
                          border: "1px solid #f0f0f0",
                          borderLeft: `4px solid ${index % 2 === 0 ? "#F2AA93" : "#B46DB8"}`,
                          borderRadius: 10,
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                            minWidth: 0,
                            flex: "1 1 200px",
                          }}
                        >
                          <Avatar size={44} icon={<UserOutlined />} style={{ flexShrink: 0 }} />
                          <div style={{ minWidth: 0 }}>
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: 15,
                                color: "#262626",
                                lineHeight: 1.3,
                              }}
                            >
                              {appointment.providerName || "Care provider"}
                            </div>
                            {!!appointment.roleName && (
                              <div style={{ color: "#7D7D7D", fontSize: 13, marginTop: 2 }}>
                                {appointment.roleName}
                              </div>
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                            fontSize: 13,
                            color: "#595959",
                            flex: "1 1 200px",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <CalendarOutlined style={{ marginRight: 8, color: "#8c8c8c" }} />
                            {appointment.startMoment.format("MMM D, YYYY")}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <ClockCircleOutlined style={{ marginRight: 8, color: "#8c8c8c" }} />
                            {appointment.endMoment
                              ? `${appointment.startMoment.format("h:mmA")} - ${appointment.endMoment.format("h:mmA")}`
                              : appointment.startMoment.format("h:mmA")}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <EnvironmentOutlined style={{ marginRight: 8, color: "#8c8c8c" }} />
                            {appointment.locationLabel}
                          </div>
                        </div>

                        <Tooltip
                          title={
                            appointment.meetingLink
                              ? ""
                              : "Join link not available yet. Please contact your care team."
                          }
                        >
                          <Button
                            type="primary"
                            style={
                              appointment.meetingLink
                                ? { background: "#00ADEF", borderColor: "#00ADEF", borderRadius: 5 }
                                : { borderRadius: 5 }
                            }
                            icon={<VideoCameraOutlined />}
                            disabled={!appointment.meetingLink}
                            onClick={() => setPendingMeetingLink(appointment.meetingLink)}
                          >
                            JOIN
                          </Button>
                        </Tooltip>
                      </div>
                    </React.Fragment>
                  ))}
                  {upcomingAppointments.length > 2 && (
                    <div onClick={handleViewAll} style={{ color: "#1E90FF", cursor: "pointer" }}>
                      {viewAll ? (
                        <UpOutlined style={{ marginRight: "10px" }} />
                      ) : (
                        <DownOutlined style={{ marginRight: "10px" }} />
                      )}
                      {viewAll ? "View Less" : "View All"}
                    </div>
                  )}
                </div>
              ) : (
                <DashboardPanelEmpty
                  icon={<CalendarOutlined />}
                  title="No upcoming appointments"
                  description={
                    isMobile
                      ? "When you book a visit, it will appear here."
                      : "When you book with your care team, your visits will appear here. Use Book or Services to schedule."
                  }
                  footer={
                    isMobile ? (
                      <p
                        style={{
                          ...dashPanelEmptyTextStyle,
                          marginTop: 14,
                          marginBottom: 0,
                          maxWidth: 340,
                          textAlign: "center",
                        }}
                      >
                        Earliest appointment you can schedule with your provider is:
                      </p>
                    ) : null
                  }
                />
              )}
            </div>
          </DashboardPanelCard>
          <DashboardPanelCard className="mt-4" title="NOTES" style={{ width: "100%" }}>
            <DashboardPanelEmpty
              icon={<FileTextOutlined />}
              title="No notes yet"
              description="Notes from your care team will appear here when they are added to your chart."
            />
          </DashboardPanelCard>
          {isMobile ? labsAndDocumentsPanels : null}
        </Col>
        {isMobile ? <>
          <img
            onClick={showCyleModal}
            src={MiraButton}
            style={{
              position: "fixed",
              right: "0px",
              bottom: "20px",
              top: "320px",
              backgroundColor: "#C2E6F8",
              borderColor: "none",
              color: "#00ADEF",
              transform: "rotateY(360deg)",
            }}
            alt="mira"
          >
          </img>
          <Modal
            title="Cycle Information"
            visible={isModalVisible}
            onOk={handleOk}
            centered
            onCancel={handleCancel}
            transitionName=""
            maskTransitionName=""
            width={600}
            bodyStyle={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              padding: "40px 16px",
            }}
            style={{
              maxWidth: '100%'
            }}
            footer={[
              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>,
            ]}
          >
            {cycleInfo && cycleInfo.cycleInfo ? (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-start', 
                alignItems: 'center',
                width: '100%',
                height: '100%',
                marginLeft: 0,
                paddingLeft: 0
              }}>
                <CircleWithArc cycleInfo={cycleInfo} dummyInfo={cycleData} />
              </div>
            ) : (
              <div
                style={{
                  width: "100%",
                  maxWidth: 360,
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {!isMale && (
                  <MiraAccountSetupMessage
                    maxTextWidth="90%"
                    imageMaxWidth={320}
                  />
                )}
              </div>
            )}
          </Modal>
        </> :
          <Col
            xs={24}
            md={9}
            lg={9}
            xl={8}
            style={{
              paddingTop: 20,
              minWidth: 0,
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {loading ? (
                  <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{
                            fontSize: 100,
                          }}
                          spin
                        />
                      }
                    />
                  </div>
                ) : cycleInfo && cycleInfo.cycleInfo ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <CircleWithArc cycleInfo={cycleInfo} />
                    {!isMale && (
                      <Button
                        type="link"
                        onClick={() => setMiraModalOpen(true)}
                        style={{ color: "#00ADEF", marginTop: 8 }}
                      >
                        Re-sync Mira
                      </Button>
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                    }}
                  >
                    {!isMale && (
                      <MiraAccountSetupMessage
                        maxTextWidth="280px"
                        imageMaxWidth={280}
                      />
                    )}
                  </div>
                )}
              </div>
              {labsAndDocumentsPanels}
            </div>
          </Col>}
      </Row>
      <MiraSyncModal
        open={miraModalOpen}
        onClose={() => setMiraModalOpen(false)}
        defaultEmail={patientEmail}
        onSynced={(payload, miraEmail) => {
          setProfileMiraEmail(miraEmail);
          if (payload) setCycleInfo(payload);
        }}
      />
      <Modal
        title={`Lab document${previewMessageNumber ? ` #${previewMessageNumber}` : ""}`}
        open={previewOpen}
        onCancel={onClosePreview}
        width={900}
        destroyOnClose
        footer={[
          <Button key="close" onClick={onClosePreview}>
            Close
          </Button>,
        ]}
      >
        {previewUrl ? (
          <iframe
            src={previewUrl}
            title={`Lab document ${previewMessageNumber || "preview"}`}
            style={{ width: "100%", height: "70vh", border: 0 }}
          />
        ) : null}
      </Modal>
      <VirtualCareConsentModal
        open={!!pendingMeetingLink}
        onCancel={() => setPendingMeetingLink(null)}
        onConfirm={handleConfirmConsent}
      />
      <style>
        {`
          input[type="checkbox"] {
            appearance: none;
            width: 20px;
            height: 20px;
            border-radius: 6px;
            border: none;
            cursor: pointer;
            margin-right: 8px;
            flex-shrink: 0;
            background-color: #E2E8F0;
            position: relative;
            transition: background-color 0.2s;
          }

          input[type="checkbox"]:checked {
            background-color: #00ADEF;
          }

          input[type="checkbox"]:checked:after {
            content: "";
            position: absolute;
            left: 6px;
            top: 2px;
            width: 6px;
            height: 12px;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
          }
        `}
      </style>

      {/* Congratulations Modal */}
      <Modal
        title={null}
        open={showCongratulationsModal}
        onOk={handleCongratulationsOk}
        onCancel={handleCongratulationsOk}
        footer={null}
        width={500}
        centered
        closable={false}
        maskClosable={false}
        transitionName=""
        maskTransitionName=""
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          {/* Great Job Graphic */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ 
              fontSize: '24px', 
              fontWeight: 'bold',
              color: '#FF69B4',
              marginBottom: '5px'
            }}>
              Great Job! ⭐
            </div>
          </div>
          
          {/* Congratulations Heading */}
          <h2 style={{ 
            color: '#00ADEF', 
            fontSize: '28px', 
            marginBottom: '20px',
            fontWeight: 'bold'
          }}>
            Congratulations!
          </h2>
          
          {/* Body Text */}
          <p style={{ 
            fontSize: '16px', 
            color: '#333', 
            marginBottom: '15px',
            lineHeight: '1.5'
          }}>
            Great job completing the first steps!
          </p>
          <p style={{ 
            fontSize: '16px', 
            color: '#333', 
            marginBottom: '25px',
            lineHeight: '1.5'
          }}>
            Contact us to book your appointment with one of our care providers.
          </p>
          
          {/* Thank You Button */}
          <Button
            type="primary"
            size="large"
            onClick={handleCongratulationsOk}
            style={{
              backgroundColor: '#00ADEF',
              borderColor: '#00ADEF',
              borderRadius: '8px',
              padding: '8px 24px',
              fontSize: '16px',
              fontWeight: '500'
            }}
          >
            Thank you!
          </Button>
        </div>
      </Modal>
    </div>
  );
}
